import { api } from '@/lib/api/client';
import { publicApi } from '@/lib/api/publicClient';

/**
 * Shared-QR groups — several stations behind one QR. Admin CRUD is authed;
 * the landing payload is public so the scanned QR can render the station
 * picker without a token.
 *
 * Backend (ox-platform):
 *   POST   /xk-qr-group                  → create { eventId, name, surveysId, stationIds }
 *   GET    /xk-qr-group?eventId=         → list for an event
 *   PUT    /xk-qr-group/:id              → update (name / survey / members)
 *   DELETE /xk-qr-group/:id              → delete (detaches stations)
 *   GET    /xk-qr-group/:id/public       → PUBLIC landing payload
 */
export interface QrGroup {
  id: number;
  name: string;
  eventId: number;
  surveysId?: number | null;
  status?: string;
  /** Member station names (attached by the list endpoint). */
  stations?: Array<{ id: number; name: string }>;
}

export interface QrGroupPublic {
  id: number;
  name: string;
  surveysId: number | null;
  stations: Array<{ id: number; name: string }>;
}

export const qrGroupApi = {
  list: (eventId: number) => api.get<QrGroup[]>(`/xk-qr-group?eventId=${eventId}`),
  create: (input: {
    eventId: number;
    name: string;
    surveysId?: number | null;
    stationIds: number[];
    companyId?: number | null;
  }) => api.post<QrGroup>('/xk-qr-group', input),
  update: (
    id: number,
    patch: { name?: string; surveysId?: number | null; stationIds?: number[] },
  ) => api.put<QrGroup>(`/xk-qr-group/${id}`, patch),
  remove: (id: number) => api.delete<{ ok: true }>(`/xk-qr-group/${id}`),
};

export const publicQrGroupApi = {
  getPublic: (groupId: number) => publicApi.get<QrGroupPublic>(`/xk-qr-group/${groupId}/public`),
};
